import {
  ChangeDetectionStrategy, Component,
} from '@angular/core'

@Component({
  selector: 'kb-card, form[kb-card], section[kb-card]',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class CardComponent {

}
